// src/axiosConfig.js
import axios from "axios";

const isBrowser = typeof window !== "undefined";
const isSWAStaging = isBrowser && /staging\.westeurope\.2\.azurestaticapps\.net$/i.test(window.location.host);
const isCustomDomain = isBrowser && window.location.host === "ghg-ecc.akdn.org";
const isSWA = isBrowser && /\.azurestaticapps\.net$/i.test(window.location.host);
const envBase = (process.env.REACT_APP_API_URL || "").trim();

export const API_BASE = isSWAStaging
  ? "https://ghg-ecc-backend-staging-hmegdzcpcycwahhu.westeurope-01.azurewebsites.net"
  : (isSWA || isCustomDomain)
  ? ""
  : (envBase || "http://localhost:8000");

function getCsrfToken() {
  if (!isBrowser) return null;
  const match = document.cookie.match(/(?:^|;\s*)csrftoken=([^;]+)/);
  return match ? decodeURIComponent(match[1]) : null;
}

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

const MUTATING = new Set(["post", "put", "patch", "delete"]);

api.interceptors.request.use((config) => {
  config.headers = config.headers || {};
  config.headers.Accept = "application/json";

  if (MUTATING.has((config.method || "").toLowerCase())) {
    const csrf = getCsrfToken();
    if (csrf) {
      config.headers["X-CSRFToken"] = csrf;
    } else {
      console.warn("[API] No CSRF token found. Call /api/auth/csrf/ first.");
    }
  }

  if (typeof FormData !== "undefined" && config.data instanceof FormData) {
    delete config.headers["Content-Type"];
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401 && isBrowser) {
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

if (isBrowser) {
  console.log("[API] baseURL =", API_BASE);
}

export default api;